import { Shirt, Sparkles, UtensilsCrossed, Smartphone, ShoppingBasket } from "lucide-react";

export const categories = [
  {
    slug: "fashion-apparel",
    icon: Shirt,
    name: "Fashion & Apparel",
    copy: "Clothing, footwear and style for every taste.",
    span: "md:col-span-7",
    img: "/assets/categories/fashion-apparel.jpg",
    alt: "Modern African and contemporary fashion — dresses, shirts, trousers, shoes, bags and accessories",
    tagline: "Style without borders.",
    intro: "From everyday essentials to statement pieces — clothing, footwear and accessories from African designers and international labels, gathered in one curated place.",
    expect: [
      "Womenswear, menswear and kids' essentials",
      "African designers alongside global labels",
      "Honest photos, clear sizing, easy browsing",
    ],
  },
  {
    slug: "beauty-cosmetics",
    icon: Sparkles,
    name: "Beauty & Cosmetics",
    copy: "Skincare, makeup and personal care essentials.",
    span: "md:col-span-5",
    img: "/assets/categories/beauty-cosmetics.jpg",
    alt: "Premium beauty products — skincare bottles, perfume, makeup palette, lipsticks and hair-care on dark stone",
    tagline: "Beauty, sourced with care.",
    intro: "Skincare, makeup, haircare and fragrance — authentic products from sellers you can trust, with the detail you need to choose well.",
    expect: [
      "Skincare, makeup, haircare and fragrance",
      "Clear shade, ingredient and usage details",
      "Authentic products from trusted sellers",
    ],
  },
  {
    slug: "foods",
    icon: UtensilsCrossed,
    name: "Foods",
    copy: "African dishes from your favourite restaurants — jollof, suya and more — ordered on Aflimart and delivered to your door.",
    span: "md:col-span-5",
    img: "/assets/categories/foods.jpg",
    alt: "A spread of diverse African dishes — jollof rice, fried rice, soups, plantain, yam, beans and fresh vegetables",
    tagline: "Your favourite dishes, delivered.",
    intro: "Foods on Aflimart means real African dishes from real restaurants — jollof, suya, swallow, grills and more — ordered in a few taps and brought to your door.",
    expect: [
      "Restaurants and kitchens in your city",
      "Jollof, suya, swallow, grills and more",
      "Hot, tracked delivery to your door",
    ],
  },
  {
    slug: "gadgets",
    icon: Smartphone,
    name: "Gadgets",
    copy: "The devices and everyday tech people love.",
    span: "md:col-span-7",
    img: "/assets/categories/gadgets.jpg",
    alt: "Modern consumer electronics — smartphone, laptop, tablet, headphones, smartwatch and accessories on a dark surface",
    tagline: "The tech you actually want.",
    intro: "Phones, audio, wearables and everyday accessories — genuine devices, clearly described, from sellers held to a standard.",
    expect: [
      "Phones, audio, wearables and accessories",
      "Clear specs and honest condition notes",
      "Genuine products from accountable sellers",
    ],
  },
  {
    slug: "groceries",
    icon: ShoppingBasket,
    name: "Groceries",
    copy: "Daily household essentials, restocked with ease.",
    span: "md:col-span-12",
    img: "/assets/categories/groceries.jpg",
    alt: "A well-organised grocery marketplace — grains, beverages, packaged foods, cooking ingredients, fresh fruits and vegetables",
    tagline: "The weekly shop, minus the queue.",
    intro: "Fresh produce, pantry staples and household essentials — restocked in minutes and delivered on your schedule.",
    expect: [
      "Fresh produce and pantry staples",
      "Household and personal essentials",
      "Delivery that fits your schedule",
    ],
  },
];
